// CSS
import "./InputBox.css"

/** 
 * This component renders an input box. Use this for single-line inputs. See TextAreaBox for multiline inputs.
 * 
 * @param   {string} type The type of input box.
 * @param   {string} placeholder The type of data to be entered.
 * @param   {string} inputName The name used to identify the element within the form.
 * @param   {boolean} required Whether or not the input field is required.
 * @param   {(e: React.ChangeEvent<HTMLInputElement>) => void} onChange The function to call when the input value is changed.
 * @param   {(e: React.FocusEvent<HTMLInputElement>) => void} onBlur The function to call when the input loses focus.
 * @returns {ReactElement} A React element that renders an input box. 
 */
export default function InputBox({type, placeholder, inputName, required, onChange, onBlur}) {
    return (
        <input 
            className="input-box" 
            type={type} 
            placeholder={placeholder} 
            name={inputName} 
            required={required}
            onChange={onChange}
            onBlur={onBlur}
        />
    )
}